<div class="flex-column gap-4">
    <div class="list-group list-group-flush settings-list-container" *ngIf="config">

		<div class="list-group-item settings-list-item">
			<div class="title-section-container flex-column gap-2" style="max-width: 25vw;">
				<b>On-click Link Scan</b>
				<span style="font-size: 0.9em;">Scans each clicked link in real time for phishing and malicious content, and rewrites the URL for secure inspection before access.<br/>
					Full documentation can be found <a href="https://docs.trustifi.com/docs/on-click-scan" target="_blank">here</a>.
				</span>
			</div>
			<div class="content-container flex-column gap-4" style="max-width: 630px;" *ngIf="config.threat_protection.url_rewrite">
				<toggle-switch-c id="onClickLinkScanToggle"
							   [(model)]="config?.threat_protection.url_rewrite.enabled"
							   (onChange)="changeOnClickScanStatus()"
							   [isDisabled]="updateUrlRewriteSettingsInProcess"></toggle-switch-c>

				<div class="flex-row gap-3 align-items-center">
					<span>Allow users to continue to URLs blocked by on-click scan</span>
					<toggle-switch-c id="allowContinueToURLToggle"
								   [(model)]="config?.threat_protection.url_rewrite.allow_malicious_onclick"
								   (onChange)="updateUrlRewriteSettings(dic.CONSTANTS.inboundUrlRewriteActions.allowMaliciousOnClick)"
								   [isDisabled]="!config?.threat_protection.url_rewrite.enabled || updateUrlRewriteSettingsInProcess"
								   [hideText]="true"></toggle-switch-c>
				</div>
				<div class="flex-row gap-3 align-items-center">
					<btn-c class="animated fadeIn" style="min-width: 0;"
						   (action)="openOnclickNotificationSettingsPopup()">
						Quarantine Notification Settings
					</btn-c>
				</div>
			</div>
		</div>

		<!--Settings: URL Hunting -->
		<div class="list-group-item settings-list-item">
			<div class="title-section-container flex-column gap-2" style="max-width: 25vw;">
				<b>URL Hunting</b>
				<span style="font-size: 0.9em;">
                    The <a class='blue-link text-decoration-underline' [routerLink]="['/' + dic.CONSTANTS.appStates.adminInbound, dic.CONSTANTS.adminPages.inbound.urlTracking]">URL Hunting</a> tool allows security teams to track and identify users who clicked on scanned links, and provide additional details like the specific location and browser/device that was used when the link was clicked.
                </span>
			</div>
			<div class="content-container flex-column gap-4" style="max-width: 630px;" *ngIf="config.threat_protection.url_rewrite">
				<toggle-switch-c id="urlHuntingToggle"
								 [(model)]="config?.threat_protection.url_rewrite.url_tracking"
								 (onChange)="updateUrlRewriteSettings(dic.CONSTANTS.inboundUrlRewriteActions.urlHunting)"
								 [isDisabled]="updateUrlRewriteSettingsInProcess"></toggle-switch-c>
			</div>
		</div>

		<!--Settings: defang URL -->
		<div class="list-group-item settings-list-item">
			<div class="title-section-container flex-column gap-2" style="max-width: 25vw;">
				<b>Defang Malicious URLs in Threat Analysis</b>
				<span style="font-size: 0.9em;">
                    URLs that have been detected as malicious will be defanged and become unclickable in the "Threat Analysis" view for increased security
                </span>
			</div>
			<div class="content-container flex-column gap-4" style="max-width: 630px;">
				<toggle-switch-c id="urlDefangeToggle"
								 [(model)]="config?.threat_protection.client_defang_malicious_url"
								 (onChange)="updateDefangeUrl();"
								 [isDisabled]="updateUrlRewriteSettingsInProcess"></toggle-switch-c>
			</div>
		</div>



		<!--third_party_seg_mta -->
		<div class="list-group-item settings-list-item">
			<div class="title-section-container flex-column gap-2" style="max-width: 25vw;">
				<b>Secure Email Gateway (SEG)</b>
				<span style="font-size: 0.9em;">Enter your Secure Email Gateway (if applicable) to bypass authentication checks for its emails to avoid misclassifications (e.g. Spoofing, Source Mismatch, Authentication Failure)</span>
			</div>
			<div class="content-container flex-column gap-2">
				<div class="flex-row gap-1">
					<input type="text" style="width: 51%; margin: 0;"
						   placeholder="MTA/IP/CIDR"
						   (keydown.enter)="addExisting3rdPartyMta();"
						   [(ngModel)]="mta3rdPartyAddress">
					<app-dropdown-c style="width: 150px;"
									text="{{mta3rdPartySeg?.name || mta3rdPartySeg || 'Select Type'}}"
									itemDisplayKey="name"
									[items]="mta3rdPartySegOptions"
									(onItemClicked)="mta3rdPartySeg = $event.item.name"></app-dropdown-c>
					<btn-c style="min-width: 0;"
						   endIcon="far fa-check"
						   [isDisabled]="!mta3rdPartyAddress || !mta3rdPartySeg || actionInProcess"
						   (action)="addExisting3rdPartyMta();">
					</btn-c>
				</div>
				<div *ngFor="let addressObj of config.threat_protection.third_party_seg_mta;">
					<div class="name ellipsis"
						 style="width: 52%; display: inline-block; max-width: 800px;">{{addressObj.mta}}</div>
					<div class="name ellipsis"
						 style="width: 21%; display: inline-block; max-width: 800px;">{{addressObj.seg}}</div>
					<a class="closeRed action"
					   (click)="deleteExisting3rdPartyMta(addressObj)"
					   [ngClass]="actionInProcess ? 'closeRed disableAction' : 'approveGreen'">
						<i class="far fa-times"></i>
					</a>
				</div>
			</div>
		</div>

		<!--third_party_simulation_skip -->
		<div class="list-group-item settings-list-item">
			<div class="title-section-container flex-column gap-2" style="max-width: 25vw;">
				<b>Phishing Simulation Bypass</b>
				<span style="font-size: 0.9em;">Enter Phishing Simulation service IPs and/or MTAs to bypass scans and quarantines</span>
			</div>
			<div class="content-container flex-column gap-2">
				<div class="flex-row gap-1">
					<input type="text" style="width: 51%; margin: 0;"
						   placeholder="MTA/IP/CIDR"
						   (keydown.enter)="addThirdPartySimulationSkipMta();"
						   [(ngModel)]="thirdPartySimulationSkipMTA">
					<btn-c style="min-width: 0;"
						   endIcon="far fa-check"
						   [isDisabled]="!thirdPartySimulationSkipMTA || actionInProcess"
						   (action)="addThirdPartySimulationSkipMta();">
					</btn-c>
				</div>
				<div *ngFor="let address of config.threat_protection.third_party_simulation_skip;">
					<div class="name ellipsis"
						 style="width: 52%; display: inline-block; max-width: 800px;">{{address}}</div>
					<a class="closeRed action"
					   (click)="deleteThirdPartySimulationSkipMta(address)"
					   [ngClass]="actionInProcess ? 'closeRed disableAction' : 'approveGreen'">
						<i class="far fa-times"></i>
					</a>
				</div>
			</div>
		</div>

		<div class="list-group-item settings-list-item">
			<div class="title-section-container flex-column gap-2" style="max-width: 25vw;">
				<b>Automatically release phishing simulation emails</b>
				<span style="font-size: 0.9em;">
					Emails that Trustifi has detected as phishing simulations will be automatically released, including forwards/replies of simulation emails
                </span>
			</div>
			<div class="content-container flex-column gap-4" style="max-width: 630px;">
				<toggle-switch-c id="release_threat_simulation_emails"
								 [(model)]="config?.threat_protection.release_threat_simulation_emails"
								 (onChange)="updateReleaseSimulationEmail();"></toggle-switch-c>
			</div>
		</div>

		<div class="list-group-item settings-list-item">
			<div class="title-section-container flex-column gap-2" style="max-width: 25vw;">
				<b>Skip warning labels for phishing simulation emails</b>
				<span style="font-size: 0.9em;">
					If warning labels are enabled, they will automatically be skipped for any email detected as a phishing simulation
                </span>
			</div>
			<div class="content-container flex-column gap-4" style="max-width: 630px;">
				<toggle-switch-c id="threat_simulation_skip_warning_label"
			                     [(model)]="config?.threat_protection.threat_simulation_skip_warning_label"
			                     (onChange)="updateSimulationEmailWarningLabel();"></toggle-switch-c>
			</div>
		</div>

		<div class="list-group-item settings-list-item">
			<div class="title-section-container flex-column gap-2" style="max-width: 25vw;">
				<b>Recipient Authentication for Quarantine Notifications</b>
				<span style="font-size: 0.9em;">
					Require recipients to authenticate their identity to review quarantined emails and perform actions from quarantine notifications.
				</span>
			</div>
			<div class="content-container flex-column gap-4" style="max-width: 630px;">
				<toggle-switch-c id="recipient_authentication"
								 [(model)]="config?.threat_protection.recipient_authentication"
								 (onChange)="changeRecipientAuthentication();"></toggle-switch-c>
			</div>
		</div>

		<!--Notify about emails that failed to deliver -->
		<div class="list-group-item settings-list-item">
			<div class="title-section-container flex-column gap-2" style="max-width: 25vw;">
				<b>Notify about emails that failed to deliver</b>
				<span style="font-size: 0.9em;">
					Send an automated notification about emails that failed to be delivered to the plan users.<br/><br/>
					Specify one or more mailboxes that should receive notifications about emails failing to deliver. If no mailbox is specified, notifications will be sent to the primary admin.
				</span>
			</div>
			<div class="content-container flex-column gap-5">
				<div class="flex-row justify-content-between gap-3 align-items-center" style="max-width: 445px;">
					<toggle-switch-c id="failedEmailDeliveryRecipientEnabled"
									 [(model)]="config.failed_email_delivery_notifications.enabled"
									 (onChange)="updateFailedEmailDeliverySettings()">
					</toggle-switch-c>
					<btn-c variant="text" (action)="openFailedDeliveryEmailsPopup();">
						View failed emails
					</btn-c>
				</div>
				<div class="flex-column gap-2">
					<div class="flex-row gap-2">
						<input type="text" style="width: 100%; margin: 0; max-width: 400px;"
							   [disabled]="!config.failed_email_delivery_notifications.enabled"
							   placeholder="Email address (optional)"
							   (keydown.enter)="addFailedEmailDeliveryRecipient();"
							   [(ngModel)]="failedEmailDeliveryRecipient">
						<btn-c style="min-width: 0;"
							   endIcon="far fa-check"
							   [isDisabled]="!config.failed_email_delivery_notifications.enabled || !failedEmailDeliveryRecipient || actionInProcess"
							   (action)="addFailedEmailDeliveryRecipient();">
						</btn-c>
					</div>
					<div *ngFor="let address of config.failed_email_delivery_notifications.recipients;">
						<div class="name ellipsis"
							 style="width: 52%; display: inline-block; max-width: 800px;">{{address}}</div>
						<a class="closeRed action"
						   (click)="deleteFailedEmailDeliveryRecipient(address)"
						   [ngClass]="actionInProcess ? 'closeRed disableAction' : 'approveGreen'">
							<i class="far fa-times"></i>
						</a>
					</div>
				</div>
			</div>
		</div>

		<!--Settings: Third-Party Reporting -->
		<div class="list-group-item settings-list-item">
			<div class="title-section-container flex-column gap-2" style="max-width: 25vw;">
				<b>Report from third-party client</b>
				<span style="font-size: 0.9em;">
					Integrate reporting from third-party email clients to update quarantined email status in Trustifi.
					Emails that have been reported as Spam/Phishing/Safe can be efficiently viewed from the quarantined emails page using built-in filters.
					To enable the integration, please add the email address which is specified to receive third-party reports in your organization.
				</span>
			</div>
			<div class="content-container flex-column gap-3" style="max-width: 630px;">
				<div class="flxRow gap-3 align-items-center" *ngFor="let vendorKey of thirdPartyClientVendors">
					<span class="text-capitalize fw-500" style="min-width: 80px;">{{vendorKey}}:</span>
					<!--normal-->
					<div class="flex-row gap-2 align-items-center" *ngIf="config?.threat_protection.third_party_report[vendorKey]">
						<input class="m-0" type="text" style="width: 300px;"
							   [(ngModel)]="config.threat_protection.third_party_report[vendorKey].mailbox"
							   (keyup)="detectThirdPartyReportingEmailChanges(vendorKey)"
							   (keyup.enter)="config.threat_protection.third_party_report[vendorKey].isChanged && updateThirdPartyReportingSettings(vendorKey)"
							   placeholder="Enter email address to enable">
						<btn-c class="animated fadeIn" style="min-width: 0;"
							   endIcon="far fa-check"
							   [isDisabled]="!config.threat_protection.third_party_report[vendorKey].isChanged"
							   [loading]="updateThirdPartyReportingSettingsInProcess"
							   (action)="updateThirdPartyReportingSettings(vendorKey)">
						</btn-c>
					</div>
					<loader spinnerWidth="1" *ngIf="!config?.threat_protection.third_party_report[vendorKey] && getConfigDataInProcess" height="35" width="35"></loader>
				</div>

				<div class="flxRow gap-3 align-items-center">
					<toggle-switch-c id="thirdPartyReportBlocklist"
									 [(model)]="config.threat_protection.third_party_report.blocklist"
									 [hideText]="true"
									 [isDisabled]="updateThirdPartyReportingSettingsInProcess"
									 (onChange)="updateThirdPartyReportingSettings('blocklist')">
					</toggle-switch-c>
					<label for="thirdPartyReportBlocklist" class="m-0">Add reported phish senders to blocklist</label>
				</div>
			</div>
		</div>
    </div>
</div>

<popup-c class="overflownV" *ngIf="onclickNotificationSettingsPopup?.show"
		 head="Notification Settings"
		 subTitle="Modify the text displayed in the notifications of URLs blocked by on-click scan."
		 size="dynamic"
		 (closeCb)="onclickNotificationSettingsPopup = null;"
		 (confirmCb)="updateOnclickNotificationSettings()"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Confirm', loading: onclickNotificationSettingsPopup.inProcess}}">
	<div class="flxClmn f-1-0 vSpace1" style="overflow: auto;">
		<div class="flxClmn gap-2">
			<span>Title:</span>
			<input type="text" style="width: 100%;" [(ngModel)]="onclickNotificationSettingsPopup.title" placeholder="Malicious Website Ahead">

			<br/>

			<span>Body:</span>
			<textarea style="width: 100%; max-height: 100px;" [(ngModel)]="onclickNotificationSettingsPopup.body" placeholder="This URL has been detected as malicious by Inbound Shield and access to it has been blocked.">
			</textarea>
		</div>
	</div>
</popup-c>

<!--failed delivery emails popup-->
<popup-c *ngIf="failedDeliveryEmailsPopup?.show"
		 head="Failed Delivery Emails"
		 subTitle="Overview of the most recent delivery failures"
		 size="large" width="1500px"
		 (closeCb)="failedDeliveryEmailsPopup = null;">
	<div class="flex-column f-1-0" style="overflow: auto;">
		<trustifi-table-c class="f-1-0 flxClmn overflow-auto" style="height: 500px;"
						[list]="failedDeliveryEmailsPopup.mtaErrors"
						[headers]="[
							{text: 'Created', sortKey: 'created', width: '145px'},
							{text: 'Subject', sortKey: 'subject', width: '15%'},
							{text: 'Message ID', sortKey: 'message_id', width: '20%'},
							{text: 'From', sortKey: 'from', width: '15%'},
							{text: 'To', sortKey: 'rcptTo', width: '15%'},
							{text: 'Error'},
					   ]"
						[cellsPrototype]="[
							{textKey: 'created', textType: 'dateAndTime'},
							{textKey: 'subject', style: {'word-break' : 'break-all'}},
							{textKey: 'message_id', style: {'word-break' : 'break-all'}},
							{textKey: 'from', style: {'word-break' : 'break-all'}},
							{textKey: 'rcptTo', style: {'word-break' : 'break-all'}},
							{textKey: 'text', style: {'word-break' : 'break-all'}},
						]"
						(searchFunction)="searchFailedDeliveryEmail($event.searchTerm, $event.activeFilters)"
						[options]="{
						  refreshFunction: getPlanMtaErrors,
						  isEllipsis: false,
						  loadingTableFlag: failedDeliveryEmailsPopup.loading,
						  defaultSortKey: '-created'
						}"
		>
		</trustifi-table-c>
	</div>
</popup-c>
